"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertServerSideNetworkAdaptionEnumToSignaled = exports.convertServerSideNetworkAdaptionEnumFromSignaled = exports.serverSideNetworkAdaptionIsNoneOrDefault = exports.ServerSideNetworkAdaption = void 0;
const SignalingProtocol_1 = require("../signalingprotocol/SignalingProtocol");
/**
 * [[ServerSideNetworkAdaption]] represents additional server side features that can be enabled for network adaption.
 */
var ServerSideNetworkAdaption;
(function (ServerSideNetworkAdaption) {
    /**
     * This value will currently be overwritten to `BandwidthProbingAndRemoteVideoQualityAdaption`
     */
    ServerSideNetworkAdaption[ServerSideNetworkAdaption["Default"] = 0] = "Default";
    /**
     * @deprecated: Please switch to 'BandwidthProbingAndRemoteVideoQualityAdaption'
     */
    ServerSideNetworkAdaption[ServerSideNetworkAdaption["None"] = 1] = "None";
    /**
     * @deprecated: Please switch to 'BandwidthProbingAndRemoteVideoQualityAdaption'.
     */
    ServerSideNetworkAdaption[ServerSideNetworkAdaption["BandwidthProbing"] = 2] = "BandwidthProbing";
    /**
     * Disable internal policy behavior and proxy priorities to server to automatically
     * switch, pause, or resume streams based on server calculated network constraints. This will
     * significantly improve response times when network constraints occur. This will also support the
     * features covered in `BandwidthProbing` though possibly with different implementation details.
     *
     * End users should overall see reduced video freezes, reduced broken audio, and reduced packet loss.
     * The value impacts response to network events and may lead to remote video pauses/downgrades
     * that did not occur before.
     */
    ServerSideNetworkAdaption[ServerSideNetworkAdaption["BandwidthProbingAndRemoteVideoQualityAdaption"] = 3] = "BandwidthProbingAndRemoteVideoQualityAdaption";
})(ServerSideNetworkAdaption = exports.ServerSideNetworkAdaption || (exports.ServerSideNetworkAdaption = {}));
exports.default = ServerSideNetworkAdaption;
function serverSideNetworkAdaptionIsNoneOrDefault(adaption) {
    return (adaption === ServerSideNetworkAdaption.None || adaption === ServerSideNetworkAdaption.Default);
}
exports.serverSideNetworkAdaptionIsNoneOrDefault = serverSideNetworkAdaptionIsNoneOrDefault;
function convertServerSideNetworkAdaptionEnumFromSignaled(adaption) {
    switch (adaption) {
        case SignalingProtocol_1.SdkServerSideNetworkAdaption.DEFAULT:
            return ServerSideNetworkAdaption.Default;
        case SignalingProtocol_1.SdkServerSideNetworkAdaption.NONE:
            return ServerSideNetworkAdaption.None;
        case SignalingProtocol_1.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING:
            return ServerSideNetworkAdaption.BandwidthProbing;
        case SignalingProtocol_1.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION:
            return ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption;
    }
}
exports.convertServerSideNetworkAdaptionEnumFromSignaled = convertServerSideNetworkAdaptionEnumFromSignaled;
function convertServerSideNetworkAdaptionEnumToSignaled(adaption) {
    switch (adaption) {
        case ServerSideNetworkAdaption.Default:
            return SignalingProtocol_1.SdkServerSideNetworkAdaption.DEFAULT;
        case ServerSideNetworkAdaption.None:
            return SignalingProtocol_1.SdkServerSideNetworkAdaption.NONE;
        case ServerSideNetworkAdaption.BandwidthProbing:
            return SignalingProtocol_1.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING;
        case ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption:
            return SignalingProtocol_1.SdkServerSideNetworkAdaption.BANDWIDTH_PROBING_AND_VIDEO_QUALITY_ADAPTION;
    }
}
exports.convertServerSideNetworkAdaptionEnumToSignaled = convertServerSideNetworkAdaptionEnumToSignaled;
//# sourceMappingURL=ServerSideNetworkAdaption.js.map